jQuery(document).ready(function($) {

  fetch('/cart.js', {
    method: 'GET',
    headers: {'Content-Type': 'application/json'}
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    var cartData = data;
    new CustomEvent('cart-initiated', {'detail': {cart: cartData }})

    CartJS.init(cartData, {
      "dataAPI": true,
      "moneyFormat": window.moneyFormat,
      "moneyWithCurrencyFormat": window.moneyWithCurrencyFormat
    });
  })
  .catch((error) => {
    console.error('Error:', error);
  });

  jQuery(document).on('cart.ready', function(event, cart) {
    window.dispatchEvent( new CustomEvent('cart-count-update', {'detail': {cartCount: cart.item_count }}) );
    window.dispatchEvent( new CustomEvent('cart-initiated', {'detail': {cart: cart }}) );
  });

  jQuery(document).on('cart.requestStarted', function(event, cart) {
    window.dispatchEvent( new CustomEvent('open-cart', {'detail': {open: true}}) );
    window.dispatchEvent( new CustomEvent('cart-loading', {'detail': {loading: true}}))
  });

  jQuery(document).on('cart.requestComplete', function(event, cart) {
    window.dispatchEvent( new CustomEvent('cart-update', {'detail': {cart: cart, loading: false}}))
    window.dispatchEvent( new CustomEvent('cart-count-update', {'detail': {cartCount: cart.item_count }}) );
  });
  

  try {
    var url = new URL(window.location.href);
    if (url.searchParams.get('open_cart')) {
      window.dispatchEvent( new CustomEvent('open-cart', {'detail': {open: true}}) );
    } 
  } catch (e) {}
});